<script lang="ts" setup>
import { useLessonRoomStore } from '@stores/lesson-room'

import { useTracksLiveKit } from '@hooks/classroom/tracks-live-kit.hook'
import { useLessonRoomAnalytics } from '@hooks/lesson-room/lesson-room-analytics.hook'

import LessonRoomControlButton from '@Atoms/LessonRoom/LessonRoomControlButton.vue'

defineOptions({
  name: 'LiveKitButtonCamera',
})

const lessonRoomStore = useLessonRoomStore()
const { trackClickCam } = useLessonRoomAnalytics()

const {
  isCameraEnabled,
  toggleCamera,
} = useTracksLiveKit()

const handleClick = (): void => {
  trackClickCam()

  if (lessonRoomStore.isDeniedCam) {
    lessonRoomStore.setPermissionsBlocked(true)
    return
  }

  void toggleCamera()
}
</script>

<template>
  <LessonRoomControlButton
    :icon="isCameraEnabled ? { name: 'video' } : { name: 'video-slash' }"
    label="Camera"
    :enabled="isCameraEnabled"
    :danger="!isCameraEnabled"
    :alert="lessonRoomStore.isDeniedCam"
    @click="handleClick"
  />
</template>
